// linediff — a minimal LCS line diff for the editor-history version viewer.
// Pure (no DOM), so it's unit-testable. Returns a flat list of ops:
//   { type: 'ctx' | 'add' | 'del', text }
// 'del' lines come from `a` (the older version), 'add' from `b` (the newer).
//
// LCS table is O(n*m); query buffers are small, so that's fine.

export function lineDiff(a, b) {
  const A = String(a == null ? '' : a).split('\n');
  const B = String(b == null ? '' : b).split('\n');
  const n = A.length, m = B.length;

  // LCS length table.
  const lcs = Array.from({ length: n + 1 }, () => new Int32Array(m + 1));
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      lcs[i][j] = A[i] === B[j] ? lcs[i + 1][j + 1] + 1 : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
    }
  }

  // Walk the table to emit ops (deletions before additions on a divergence).
  const ops = [];
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (A[i] === B[j]) { ops.push({ type: 'ctx', text: A[i] }); i++; j++; }
    else if (lcs[i + 1][j] >= lcs[i][j + 1]) { ops.push({ type: 'del', text: A[i] }); i++; }
    else { ops.push({ type: 'add', text: B[j] }); j++; }
  }
  while (i < n) { ops.push({ type: 'del', text: A[i] }); i++; }
  while (j < m) { ops.push({ type: 'add', text: B[j] }); j++; }
  return ops;
}

// diffStats summarizes a diff as { added, removed } changed-line counts.
export function diffStats(ops) {
  let added = 0, removed = 0;
  for (const o of ops) {
    if (o.type === 'add') added++;
    else if (o.type === 'del') removed++;
  }
  return { added, removed };
}
